import { map, pick } from 'lodash'

import { CHALLENGE_TYPES } from '../../../common/constants'

const transformToUpdateChallengeRelationsDetailsArgs = data => ({
  ...pick(data, ['type', 'dishTypes', 'cuisineTypes']),
  dishTypes:
    data.type === CHALLENGE_TYPES.CUISINE_TYPE
      ? []
      : map(data.dishTypes, item => item?.value ?? item),
  cuisineTypes:
    data.type === CHALLENGE_TYPES.DISH_TYPE
      ? []
      : map(data.cuisineTypes, item => item?.value ?? item),
})

export default transformToUpdateChallengeRelationsDetailsArgs
